const audioFiles = ['audio1.png', 'audio2.png', 'audio3.png', 'audio4.png', 'audio5.png', 'audio6.png', 'audio7.png', 'audio8.png'];
const documentFiles = ['doc1.png', 'doc2.png', 'doc3.png', 'doc4.png', 'doc5.png', 'doc6.png', 'doc7.png', 'doc8.png'];
const imageFiles  = ['img1.png', 'img2.png', 'img3.png', 'img4.png', 'img5.png', 'img6.png', 'img7.png', 'img8.png'];
const textColors = ['#EB6756', '#EB8C56', '#EBB756', '#4AD9A8', '#0D2C78', '#2B0D78'];
const videoFiles  = ['v1.png', 'v2.png', 'v3.png', 'v4.png', 'v5.png', 'v6.png','v7.png', 'v8.png'];
export const backgColorProperty = {
  audio: audioFiles.map(file => `url(${require(`@/assets/school/${file}`)})`),
  document: documentFiles.map(file => `url(${require(`@/assets/school/${file}`)})`),
  image: imageFiles.map(file => `url(${require(`@/assets/school/${file}`)})`),
  video: videoFiles.map(file => `url(${require(`@/assets/school/${file}`)})`),
  textcolor: textColors
};